import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller.ts"
import type { IRoleServiceProviderMachine } from "@/interfaces/api/role-service-provider-machine.interface.ts"
import { RoleServiceProviderMachineRepository } from "@/repositories/role-service-provider-machine-repository.ts"
import { RoleServiceProviderMachine } from "@/models/role-service-provider-machine.model.ts"
import { useRoleServiceProviderRolesStore } from "@/store/role-service-provider-machines.store.ts"

export class RoleServiceProviderMachineController extends GenericModelController<
  RoleServiceProviderMachine,
  IRoleServiceProviderMachine,
  RoleServiceProviderMachineRepository
> {
  constructor() {
    const { pushToRelatedObjects, removeFromRelatedObjects } = useRoleServiceProviderRolesStore()
    const storeFunctionsConfig = {
      onCreate: pushToRelatedObjects,
      onDelete: removeFromRelatedObjects
    }

    super(
      RoleServiceProviderMachine,
      storeFunctionsConfig,
      new RoleServiceProviderMachineRepository()
    )
  }
}
